module.exports = __webpack_public_path__ + "img/katarina_outside_13.58e300b2.jpg";